import { Component } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd, RouterLink } from "@angular/router";
import { filter, distinctUntilChanged, map } from "rxjs/operators";
import { RoleType } from "src/app/core/_models/role";
import { UserFacadeService } from "src/app/core/facades/userfacade/userfacade.service";
import { NgFor, NgClass, NgIf } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

interface IBreadCrumb {
  label: string;
  url: string;
}

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
  imports: [NgFor, NgClass, NgIf, RouterLink, TranslatePipe],
})
export class BreadcrumbComponent {
  role: any;
  public breadcrumbs: IBreadCrumb[] = [];
  specialCase = {
    userprofile: "breadcrumb.USERPROFILE",
    organizationprofile: "breadcrumb.ORGANIZATIONPROFILE",
    paymentmethod: "breadcrumb.PAYMENTMETHOD",
    subscription: "breadcrumb.SUBSCRIPTION",
    user: "breadcrumb.USERS",
    invoices: "breadcrumb.INVOICES",
    groups: "breadcrumb.GROUPS",
    account: "breadcrumb.RESETPASSWORD",
    resources: "breadcrumb.RESOURCES",
    demand: "breadcrumb.DEMAND",
  };
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userFacadeService: UserFacadeService,
  ) {
    this.userFacadeService.user.subscribe((user) => {
      if (user) {
        if (user.permissions.find((role) => role.value == RoleType.HXAMaster)) {
          this.role = true;
        } else {
          this.role = false;
        }
      }
    });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged(),
        map(() => this.buildBreadCrumb(this.activatedRoute.root, this.role)),
      )
      .subscribe((breadcrumbs) => (this.breadcrumbs = breadcrumbs));
  }

  buildBreadCrumb(
    route: ActivatedRoute,
    role: any,
    url = "",
    breadcrumbs: IBreadCrumb[] = [],
  ): IBreadCrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join("/");
      const groupsBreadcrumb = {
        label: "breadcrumb.GROUPS",
        url: "account/groups",
      };
      if (url === "/profile/groups") {
        breadcrumbs.push(groupsBreadcrumb);
        breadcrumbs = breadcrumbs.filter(
          (breadcrumb) => breadcrumb.url !== "/account/groups",
        );
      }
      if (routeURL !== "") {
        url += `/${routeURL}`;

        let label: string = child.snapshot.data["breadcrumb"] || routeURL;
        if (child.snapshot.params["cat"]) {
          label = `breadcrumb.${child.snapshot.params["cat"].toUpperCase()}`;
        }
        if (label in this.specialCase) label = this.specialCase[label];

        const customerManagerBreadcrumb = {
          label: "breadcrumb.CUSTOMERMANAGER",
          url: "customer-manager",
        };
        const profileBreadcrumb = {
          label: "breadcrumb.USERS",
          url: "account/user",
        };

        if (["breadcrumb.NEWCUSTOMER", "breadcrumb.CUSTOMERDETAILS"].includes(label)) {
          breadcrumbs.push(customerManagerBreadcrumb);
        }
        if (
          ["breadcrumb.ORGANIZATIONPROFILE"].includes(label) &&
          role &&
          !breadcrumbs.some(
            (crumb) =>
              crumb.label === customerManagerBreadcrumb.label &&
              crumb.url === customerManagerBreadcrumb.url,
          )
        ) {
          breadcrumbs.push(customerManagerBreadcrumb);
        }
        if (["breadcrumb.role-details", "breadcrumb.role"].includes(label)) {
          breadcrumbs.push(profileBreadcrumb);
        } else if (label === "breadcrumb.ADDMEMBER") {
          const editGroupUrl = url.replace("/add-member", "");
          const editGroupBreadcrumb = {
            label: "breadcrumb.EDITSECURITY",
            url: editGroupUrl,
          };
          breadcrumbs.push(editGroupBreadcrumb);
          breadcrumbs.push({ label, url });
        } else {
          breadcrumbs.push({ label, url });
        }
      }
      return this.buildBreadCrumb(child, role, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
